import React, { useEffect } from 'react';

import { PrintingDetails as View } from '@views';
import { trackEvent } from '@utils/mixpanel';

const PrintingDetails = () => {
  useEffect(() => {
    const pageTitle = 'Mindspace: Printing & Scaning';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Printing Details',
    });
  }, []);

  return (
    <View />
  );
};

export default PrintingDetails;
